module.exports = __webpack_public_path__ + "img/github_white.8a26cd80.svg";